// Captura UNIFICADA por corrida (cadencia 'libre') — plan unificación tiendas↔líneas.
// Post-flip la planilla del líder de tiendas escribe directo en el modelo
// unificado (registros_produccion_hora): la corrida es una fila de la
// tienda-LÍNEA con bloque por rango fake-UTC y cadencia 'libre'.
//
// Espeja el contrato estricto de registros_tienda (turno DERIVADO de la
// programación, nunca del body; bulk atómico) — la delegación de supervisor
// sigue fuera del alcance (403 en la ruta).
import { z } from 'zod';
export const registroLibreCreateSchema = z
    .object({
    /** Tienda-línea destino (lineas.es_tienda, cadencia efectiva 'libre'). */
    linea_id: z.string().uuid(),
    sku_id: z.string().uuid(),
    /** Rango fake-UTC (pared local etiquetada Z), compuesto por el FE con
     *  combinarFechaHoraTurno — idéntico al contrato de registros_tienda. */
    bloque_inicio: z.string().datetime({ offset: true }),
    bloque_fin: z.string().datetime({ offset: true }),
    /** OP/OC del cliente (tiendas: numeración SAP de 10 dígitos, D9). */
    op_lote_oc_cliente: z
        .string()
        .trim()
        .regex(/^\d{10}$/, 'La orden de tiendas debe tener 10 dígitos'),
    cantidad_procesada: z.number().positive('Debe ser mayor a 0'),
    numero_operarios: z.number().int().min(1).max(60).nullable().default(null),
    cantidad_stickers: z.number().int().min(0).nullable().default(null),
    cantidad_termos: z.number().int().min(0).nullable().default(null),
})
    .refine((r) => new Date(r.bloque_fin).getTime() > new Date(r.bloque_inicio).getTime(), {
    message: 'bloque_fin debe ser posterior a bloque_inicio',
    path: ['bloque_fin'],
});
export const registrosLibreBulkCreateSchema = z.object({
    /** Opción B (paridad con registros_tienda): si viene, debe coincidir con el
     *  turno DERIVADO de la programación — nunca se confía del body. */
    turno_id: z.string().uuid().nullable().default(null),
    registros: z
        .array(registroLibreCreateSchema)
        .min(1, 'Al menos una corrida')
        .max(100, 'Máximo 100 corridas por envío'),
});
//# sourceMappingURL=registro_bulk_libre.js.map